/**
 * Clearance item dispatch date validation for cart page and cart drawer.
 * Shows a warning message and disables the checkout button when the cart
 * contains a clearance item AND a dispatch date has been applied.
 */

(function () {
  'use strict';

  function hasClearanceItem() {
    return !!document.querySelector('.cart-item[data-is-clearance="true"]');
  }

  function hasAnyForwardDeliveryDate() {
    for (const item of document.querySelectorAll('.cart-item[data-forward-delivery-date]')) {
      if (item.dataset.forwardDeliveryDate) return true;
    }
    return false;
  }

  function checkClearanceValidation() {
    // Clearance/dispatch-date constraint temporarily disabled — shipped to production prematurely.
    // Ensure any server-rendered warning messages are hidden in case the Liquid override is bypassed.
    const mainMessageEl = document.getElementById('cart-clearance-message');
    if (mainMessageEl) mainMessageEl.hidden = true;
    const drawerMessageEl = document.getElementById('cart-drawer-clearance-message');
    if (drawerMessageEl) drawerMessageEl.hidden = true;
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(checkClearanceValidation, 200);
    });
  } else {
    setTimeout(checkClearanceValidation, 200);
  }

  // Re-run whenever the cart updates
  document.addEventListener('cart:updated', checkClearanceValidation);

  // Watch for cart drawer open
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    cartDrawer.addEventListener('cart:open', checkClearanceValidation);

    const drawerObserver = new MutationObserver(function (mutations) {
      for (const mutation of mutations) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
          if (cartDrawer.getAttribute('aria-hidden') !== 'true') {
            checkClearanceValidation();
          }
          break;
        }
      }
    });
    drawerObserver.observe(cartDrawer, { attributes: true, attributeFilter: ['aria-hidden'] });
  }

  window.checkClearanceValidation = checkClearanceValidation;
})();
